import Imm from 'immutable';
import { createSelector } from 'reselect';


export const getRoot = state => state.get('users') || state;

export const getUserData = state => getRoot(state).get('data');

export const getSSOData = (state) => {
    const ssoData = getRoot(state).get('ssoData');
    return ssoData;
};

export const isFetchingSSOData = state => getRoot(state).get('loading');


const formFields = [
    'firstname',
    'lastname',
    'feature_flags',
    'primary_email',
    'postal_code',
    'gender',
    'deleted',
    'archived',
    'wants_email',
    'wants_newsletter',
    'wants_sms',
];

export const getInitialFormData = createSelector(
    getUserData,
    data => (data.isEmpty()
        ? data
        : formFields.reduce((res, i) => res.set(i, data.get(i)), Imm.Map())),
);

export const getUserID = state => getUserData(state).get('id');
